<!-- src/components/View40.vue -->
<template>
  <div :class="['view-339', { 'view-339--header': variant === 'header' }]">
    <div class="rectangle-181-2"></div>
    
    <!-- Поле ввода для поиска -->
    <input
      v-model="searchQuery"
      type="text"
      class="search-input poppins-normal-black-17px"
      :placeholder="placeholder"
      @keyup.enter="handleSearch"
      @input="handleInput"
      :aria-label="placeholder"
    />
    
    <!-- Кнопка поиска -->
    <button
      type="button"
      class="view-340"
      @click="handleSearch"
      :aria-label="buttonLabel"
      :disabled="isSearchDisabled"
    >
      <div class="rectangle-81-25"></div>
      <span class="text-372 poppins-bold-white-12px">{{ buttonText }}</span>
      <img
        class="vector-237"
        src="https://cdn.animaapp.com/projects/68d55a995799e527ee530c15/releases/68d96a345506c1136576f4d8/img/vector-65.svg"
        alt=""
        role="presentation"
      />
    </button>
  </div>
</template>

<script>
export default {
  name: 'View40',
  
  props: {
    variant: {
      type: String,
      default: 'default',
      validator: value => ['default', 'header'].includes(value)
    },
    placeholder: {
      type: String,
      default: 'Найти курс'
    },
    buttonText: {
      type: String,
      default: 'Найти'
    },
    buttonLabel: {
      type: String,
      default: 'Выполнить поиск'
    },
    debounce: {
      type: Number,
      default: 0
    }
  },
  
  emits: ['search', 'input'],
  
  data() {
    return {
      searchQuery: '',
      debounceTimer: null
    }
  },
  
  computed: {
    isSearchDisabled() {
      return !this.searchQuery.trim()
    }
  },
  
  methods: {
    handleSearch() {
      const query = this.searchQuery.trim()
      
      if (!query) {
        return
      }
      
      // Emit события для родительского компонента
      this.$emit('search', query)
      
      // Если не в режиме хедера, выполняем навигацию
      if (this.variant !== 'header') {
        this.$router.push({
          path: '/search-courses',
          query: { q: query }
        })
      }
    },
    
    handleInput() {
      // Очищаем предыдущий таймер
      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer)
      }
      
      // Если debounce включен
      if (this.debounce > 0) {
        this.debounceTimer = setTimeout(() => {
          this.$emit('input', this.searchQuery)
        }, this.debounce)
      } else {
        this.$emit('input', this.searchQuery)
      }
    },
    
    clear() {
      this.searchQuery = ''
      this.$emit('input', '')
      this.$emit('search', '')
    },
    
    focus() {
      this.$refs.input?.focus()
    }
  },
  
  beforeUnmount() {
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer)
    }
  }
}
</script>

<style>
/* Оригинальные стили для обратной совместимости */
.view-339,
.view-341,
.view-344,
.view-348,
.view-350,
.view-352,
.view-354,
.view-356,
.view-358,
.view-360,
.view-362,
.view-364,
.view-366,
.view-368,
.view-370 {
  height: 33px;
  left: 358px;
  position: absolute;
  top: 1px;
  width: 398px;
}

.rectangle-181-2,
.rectangle-181-3,
.rectangle-181-4,
.rectangle-181-5,
.rectangle-181-6,
.rectangle-181-7,
.rectangle-181-8,
.rectangle-181-9,
.rectangle-181-10,
.rectangle-181-11,
.rectangle-181-12,
.rectangle-181-13,
.rectangle-181-14,
.rectangle-181-15,
.rectangle-181-16 {
  background-color: var(--black-9, #f5f5f5);
  border-radius: 50px;
  height: 33px;
  left: 0;
  position: absolute;
  top: 0;
  width: 396px;
}

/* Стили для поля ввода поиска */
.search-input {
  position: absolute;
  left: 38px;
  top: 3px;
  width: 250px;
  height: 27px;
  background: transparent;
  border: none;
  outline: none;
  color: var(--black, #000);
  font-size: 17px;
  letter-spacing: 0.68px;
  padding: 0;
  z-index: 1;
}

.search-input::placeholder {
  color: rgba(0, 0, 0, 0.5);
}

.search-input:focus {
  color: var(--black, #000);
}

/* Стили для кнопки */
.view-340,
.view-342,
.view-345,
.view-349,
.view-351,
.view-353,
.view-355,
.view-357,
.view-359,
.view-361,
.view-363,
.view-365,
.view-367,
.view-369,
.view-371 {
  height: 22px;
  left: 298px;
  position: absolute;
  top: 6px;
  width: 87px;
  cursor: pointer;
  transition: transform 0.2s ease, opacity 0.2s ease;
  background: none;
  border: none;
  padding: 0;
}

.view-340:hover:not(:disabled) {
  transform: scale(1.05);
  opacity: 0.9;
}

.view-340:active:not(:disabled) {
  transform: scale(0.95);
}

.view-340:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.view-340:focus-visible {
  outline: 2px solid var(--azure-radiance-3, #007bff);
  outline-offset: 2px;
  border-radius: 20px;
}

.rectangle-81-25,
.rectangle-81-26,
.rectangle-81-27,
.rectangle-81-28,
.rectangle-81-29,
.rectangle-81-30,
.rectangle-81-31,
.rectangle-81-32,
.rectangle-81-33,
.rectangle-81-34,
.rectangle-81-35,
.rectangle-81-36,
.rectangle-81-37,
.rectangle-81-38,
.rectangle-81-39 {
  background-color: var(--azure-radiance-3, #007bff);
  border-radius: 20px;
  height: 22px;
  left: 0;
  position: absolute;
  top: 0;
  width: 85px;
}

.text-372,
.text-564,
.text-657,
.text-771,
.text-954,
.text-1032,
.text-1095,
.text-1317,
.text-1426,
.text-1609,
.text-1646,
.text-1698,
.text-1732,
.text-1915,
.text-2107 {
  left: 13px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  top: 2px;
  z-index: 1;
}

.vector-237,
.vector-238,
.vector-239,
.vector-240,
.vector-241,
.vector-242,
.vector-243,
.vector-244,
.vector-245,
.vector-246,
.vector-247,
.vector-248,
.vector-249,
.vector-250,
.vector-251 {
  aspect-ratio: 1;
  height: 12px;
  left: 66.67%;
  position: absolute;
  top: calc(50% - 6px);
  width: 13.79%;
  z-index: 1;
}

/* Новые стили для header варианта */
.view-339--header {
  position: relative !important;
  left: auto !important;
  top: auto !important;
  width: 100%;
  height: 36px;
  display: flex;
  align-items: center;
}

.view-339--header .rectangle-181-2 {
  width: 100%;
  height: 100%;
  background-color: #f8f9fa;
  border: 1px solid #e9ecef;
  transition: border-color 0.2s ease, background-color 0.2s ease;
}

.view-339--header:focus-within .rectangle-181-2 {
  background-color: #fff;
  border-color: #007bff;
}

.view-339--header .search-input {
  left: 16px !important;
  width: calc(100% - 110px) !important;
  top: 50% !important;
  transform: translateY(-50%);
  font-size: 14px;
}

.view-339--header .view-340 {
  left: auto !important;
  right: 4px !important;
  top: 50% !important;
  transform: translateY(-50%);
  height: 28px;
  width: 80px;
}

.view-339--header .view-340 .rectangle-81-25 {
  height: 28px;
  width: 78px;
}

.view-339--header .view-340 .text-372 {
  top: 50%;
  transform: translateY(-50%);
  left: 12px;
}

.view-339--header .view-340 .vector-237 {
  top: 50%;
  transform: translateY(-50%);
  right: 12px;
  left: auto;
}

/* Utility классы */
.poppins-normal-black-17px {
  font-family: "Poppins", sans-serif;
  font-size: 17px;
  font-weight: 400;
}

.poppins-bold-white-12px {
  color: white;
  font-family: "Poppins", sans-serif;
  font-size: 12px;
  font-weight: 700;
}

/* Responsive для header варианта */
@media (max-width: 768px) {
  .view-339--header .search-input {
    font-size: 13px;
  }
  
  .view-339--header .view-340 {
    width: 60px;
  }
  
  .view-339--header .view-340 .text-372 {
    font-size: 11px;
  }
}
</style>